
export enum ApiTypeStatusCd {
	ARCHIVED = 'Archived',
	CANCELLED = 'Cancelled',
	IMPLEMENTED = 'Implemented',
	PENDING = 'Pending',
	SAVED = 'Saved'}

